.kdx-overlay-cta {
    min-height: 322px;
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;

    &.light  {
        .overlay {
            position: absolute;
            content: '';
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, rgba(0, 61, 113, 0.7), rgba(0, 60, 113, 0));
            z-index: 1;

        }
        .cta-container {
            .cta-content {
                h2 { font-weight: 800; }
            }
        }
    }
    &.dark {
        .overlay {
            position: absolute;
            content: '';
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, $primary, #00000078);
            z-index: 1;
        }
        .cta-container {
            .cta-content {
                h2, .h2 { 
                    margin-bottom: 1rem; 
                    font-weight: 700;
                }
            }
        }
    }
    
    picture {
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        display: block;
    }
    
    picture img {
        display: block;
        width: 100%;
        height: 100%;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        object-fit: cover;
    }

    .cta-container {
        z-index: 2;

        .cta-content {
            max-width: 50%;
            position: relative;
            padding: 48px 0 54px;
            z-index: 2;
    
            h2, .h2 {
                color: #FFFFFF;
            }

            p {
                color: #FFFFFF;
            }
    
            .ctas {
                display: flex;
                flex-direction: row;
                align-items: center;
                > a {
                    margin-right: 1.5rem;

                }
                .btn-primary, .btn-secondary { 
                    color: #FFFFFF; 
                    font-weight: 700;
                    display: flex;

                    svg { fill: #FFFFFF; }
                }
            }
        }
    }
}

@include media-breakpoint-down(lg) {
    .kdx-overlay-cta {
        padding: 0;

        &.light {
            min-height: 41rem;

            .overlay{
                min-height: 41rem; 
                padding: 0;
                top: 0;
                left: 0;
                background: linear-gradient(180deg, rgba(0, 61, 113, 0.7), rgba(0, 60, 113, 0));
                min-height: 41rem;
            }

        }
            &.dark {
                min-height: 22rem;

                .overlay {
                    max-height: 22rem; 
                    padding: 0;
                    top: 0;
                    left: 0;
                    background: linear-gradient(180deg, $primary, #00000078);
                    min-height: 22rem;
                }
                .cta-container {
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);

                    .cta-content { text-align: center; }

                    .ctas { justify-content: center; }
                }
            }

        .bg-image {
            position: relative;
            
            &-mobile {
                &.light {
                    display: block;
                    min-height: 41rem; //656px
                }
                &.dark {
                    min-height: 22rem; //353px
                    display: block;
                }
            }
        }

        .cta-container {
            position: absolute; //offsetting the content
            max-width: 100%;
            padding: 0 30px;
            margin-left: 0;
            top: 0;
    
            .cta-content {
                padding-bottom: 0.625rem;
                max-width: 100%;
                margin-left: 0;

                h2, .h2 { 
                    font-weight: 800;
                    margin-bottom: 1.5rem; 
                }

                p {
                    padding-bottom: 2.5rem;
                    @include text-size(16);
                    @include line-height(24);
                }
                .ctas {
                    a { margin-right: 0; }
                }
            }
        }
    }
}
@include media-breakpoint-down(md) {
    .kdx-overlay-cta {
        .cta-container {
            text-align: center;

            .cta-content {
                p {
                    @include text-size(14);
                    @include line-height(22);
                }
                .ctas {
                    flex-direction: column;
        
                    a { margin-bottom: 28px; }
                }
               
            }
        }
    }
}